import React from 'react';

const ContactBox = () => {
  return (
    <>
      <section className='contact-promo ptb-120'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-4 col-md-6 mt-4 mt-lg-0'>
              <div className='contact-us-promo p-5 bg-white rounded-custom custom-shadow text-center d-flex flex-column h-100'>
                <span className='fad fa-envelope fa-3x text-primary'></span>
                <div className='contact-promo-info mb-4'>
                  <h5>E-mail</h5>
                  <p>
                    Senden Sie Ihre Anfragen und Nachrichten an
                    <strong> info@elintech.de</strong>. Unser Team wird sich
                    umgehend bei Ihnen melden.
                  </p>
                </div>
                <a
                  href='mailto:info@elintech.de'
                  className='btn btn-primary mt-auto'
                >
                  Jetzt E-Mail senden
                </a>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 mt-4 mt-lg-0'>
              <div className='contact-us-promo p-5 bg-white rounded-custom custom-shadow text-center d-flex flex-column h-100'>
                <span className='fad fa-phone fa-3x text-primary'></span>
                <div className='contact-promo-info mb-4'>
                  <h5>Telefonisch</h5>
                  <p>
                    Wenn Sie uns lieber telefonisch kontaktieren möchten,
                    erreichen Sie uns unter der folgenden Telefonnummer
                  </p>
                </div>
                <a href='tel:+4917624224368' className='btn btn-link mt-auto'>
                  +49 17624224368
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactBox;

